import React, { Component } from 'react'
import TeamCard from './cards/team'

class TeamMembers extends Component {

  render() {

    let { title, items, agent } = this.props

    return (
      <section className='profile__team'>
        <div className='profile__inner'>
          <div className='profile__team-body'>
            <div className='profile__menu'> 
              <ul>
                <li className='active'>{title}</li>
              </ul>
            </div>
            { items && items.length &&
              <div className="profile__members">
                { items.map((el, i) => (
                  <TeamCard {...el} {...el.acf} {...el.teamDetails} key={i} profile={agent} />
                ))}
              </div>
            }
          </div>
        </div>
      </section>
    )
  }
}

export default TeamMembers
